function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _ from "underscore";
import PropTypes from "prop-types";
import React from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import OutsideClick from "./outside-click";
import GlobalKeypress from "./global-keypress";
var any = PropTypes.any,
    func = PropTypes.func,
    bool = PropTypes.bool,
    string = PropTypes.string; // TODO: This should use whatever overlay management we end up with

var Dropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(Dropdown, _React$Component);

  var _super = _createSuper(Dropdown);

  function Dropdown() {
    var _this;

    _classCallCheck(this, Dropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      position: "left"
    });

    _defineProperty(_assertThisInitialized(_this), "calcMaxHeight", function () {
      if (_this.mounted && _this.props.isOpen) {
        var node = _this.body;
        var windowHeight = document.body.offsetHeight;
        var cords = node.getBoundingClientRect();
        var distanceFromTop = cords.top - document.body.scrollTop;
        var paddingBottom = 15;
        var content = node.querySelector(".et--dropdown--content");
        var footer_innerHeight = __guard__(node.querySelector(".et--dropdown--footer"), function (x) {
          return x.innerHeight;
        }) || 0;
        var cssMaxHeight = content ? parseInt(getComputedStyle(content)["maxHeight"], 10) : Infinity;
        var newMaxHeight = windowHeight - distanceFromTop - paddingBottom - footer_innerHeight;
        return content != null ? content.style.maxHeight = Math.min(newMaxHeight, cssMaxHeight) : undefined;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "calcPosition", function () {
      var bodyWidth = document.body.offsetWidth;
      var pos = bodyWidth + ReactDOM.findDOMNode(_assertThisInitialized(_this)).offsetLeft;

      if (pos > bodyWidth) {
        return "right";
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleToggle", function (evnt) {
      if (!_this.props.disabled) {
        evnt.stopPropagation();

        _this.setState({
          position: _this.calcPosition()
        });

        if (!_this.props.isOpen) {
          return _this.open();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOutsideClick", function (evnt) {
      return _this.close();
    });

    _defineProperty(_assertThisInitialized(_this), "open", function () {
      return _.defer(function () {
        if (_this.mounted && !_this.props.isOpen) {
          return typeof _this.props.onOpen === "function" ? _this.props.onOpen() : undefined;
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      return _.defer(function () {
        if (_this.mounted && _this.props.isOpen) {
          return typeof _this.props.onClose === "function" ? _this.props.onClose() : undefined;
        }
      });
    });

    return _this;
  }

  _createClass(Dropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      return window.addEventListener("resize", this.calcMaxHeight);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      if (newProps.isOpen !== this.props.isOpen) {
        return this.calcMaxHeight();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      return window.removeEventListener("resize", this.calcMaxHeight);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var bodyClasses = classNames("et--dropdown--body", {
        "is-open": this.props.isOpen,
        "is-right": this.state.position === "right"
      });
      return /*#__PURE__*/React.createElement("div", {
        className: classNames("et--dropdown", this.props.className)
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames("et--dropdown--header", {
          "is-disabled": this.props.disabled
        })
      }, /*#__PURE__*/React.createElement("span", {
        "aria-label": this.props.label,
        role: "button",
        tabIndex: this.props.disabled ? undefined : 0,
        onClick: this.handleToggle,
        className: classNames("et--dropdown--toggle", {
          "is-open": this.props.isOpen
        })
      }, this.props.header)), /*#__PURE__*/React.createElement("div", {
        className: "et--advanced-combobox--content-wrapper",
        ref: function ref(e) {
          return _this2.body = e;
        }
      }, this.props.isOpen ? /*#__PURE__*/React.createElement(OutsideClick, {
        className: bodyClasses,
        onOutsideClick: this.handleOutsideClick
      }, this.props.children) : undefined, this.props.isOpen ? /*#__PURE__*/React.createElement(GlobalKeypress, {
        onEscape: this.close
      }) : undefined));
    }
  }]);

  return Dropdown;
}(React.Component);

_defineProperty(Dropdown, "displayName", "Dropdown");

_defineProperty(Dropdown, "propTypes", {
  label: string,
  header: any,
  disabled: bool,
  isOpen: bool,
  closeOnUpdate: bool,
  onOpen: func,
  onClose: func
});

export { Dropdown as default };

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null ? transform(value) : undefined;
}